var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "selectMenu" }, [
    _vm.open
      ? _c("div", {
          staticClass: "backdrop",
          on: {
            click: function ($event) {
              return _vm.$emit("closeMenu")
            },
          },
        })
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { ref: "menuMobile", class: ["menuMobile", { open: _vm.open }] },
      [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "header" }, [_vm._t("default")], 2),
          _vm._v(" "),
          _vm.open
            ? _c(
                "ul",
                {
                  staticClass: "items",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("closeMenu")
                    },
                  },
                },
                _vm._l(_vm.menuItems, function (item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "item",
                      on: {
                        click: function ($event) {
                          return _vm.clickItem(item)
                        },
                      },
                    },
                    [
                      item.icon
                        ? _c("i", { staticClass: "material-icons icon" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(item.icon) +
                                "\n\t\t\t\t\t"
                            ),
                          ])
                        : _vm._e(),
                      _vm._v("\n\t\t\t\t\t" + _vm._s(item.text) + "\n\t\t\t\t"),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { ref: "menuDesktop", class: ["menuDesktop", { open: _vm.open }] },
      [
        _c("div", { staticClass: "header" }, [_vm._t("default")], 2),
        _vm._v(" "),
        _vm.open
          ? _c(
              "ul",
              {
                staticClass: "items",
                on: {
                  click: function ($event) {
                    return _vm.$emit("closeMenu")
                  },
                },
              },
              _vm._l(_vm.menuItems, function (item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "item",
                    on: {
                      click: function ($event) {
                        return _vm.clickItem(item)
                      },
                    },
                  },
                  [
                    item.icon
                      ? _c("i", { staticClass: "material-icons icon" }, [
                          _vm._v(
                            "\n\t\t\t\t\t" + _vm._s(item.icon) + "\n\t\t\t\t"
                          ),
                        ])
                      : _vm._e(),
                    _vm._v("\n\t\t\t\t" + _vm._s(item.text) + "\n\t\t\t"),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }